/**
 * OrderLineAddOnService
 * Service for OrderLineAddOn entity operations
 * Route: api/orderlineaddons
 * Controller: OrderLineAddOnsController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * OrderLineAddOnService
 * Handles order line add-on CRUD operations.
 * Backend now returns OrderLineAddOnModelView (enriched) instead of raw entities.
 * Maps to /api/orderlineaddons endpoint
 */
export class OrderLineAddOnService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? OrderLineAddOnService.DEFAULT_SERVICE_PATH,
            basePath: OrderLineAddOnService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== QUERY BY LINE ====================
    /**
     * Get order line add-ons by line ID
     * GET /api/orderlineaddons?lineId={lineId}
     */
    async getByLineId(lineId) {
        const response = await this.getByLineIdRaw(lineId);
        return response.data ?? [];
    }
    /**
     * Get order line add-ons by line ID (raw)
     */
    getByLineIdRaw(lineId) {
        const url = this.buildUrl(`?lineId=${lineId}`);
        return this.http.get(url);
    }
}
OrderLineAddOnService.DEFAULT_SERVICE_PATH = 'orders';
OrderLineAddOnService.BASE_PATH = 'api/orderlineaddons';
//# sourceMappingURL=OrderLineAddOnService.js.map